import { useEffect, useState } from "react";

const useGeolocation = () => {
    const [location, setLocation] = useState<{ lat: number; lon: number } | null>(null);
    const [error, setError] = useState<string | null>(null);

    const getLocation = () => {
        if (!navigator.geolocation) {
            setError("Geolocation is not supported by your browser.");
            return;
        }

        navigator.geolocation.getCurrentPosition(
            (position) => {
                setLocation({
                    lat: position.coords.latitude,
                    lon: position.coords.longitude,
                });
                setError(null);
            },
            (err) => {
                if (err.code === err.PERMISSION_DENIED) {
                    setError("Location permission denied. Please allow access to see map.");
                } else {
                    setError("Unable to retrieve location.");
                }
            }
        );
    };

    useEffect(() => {
        getLocation();
    })

    return { location, error, getLocation };
};

export default useGeolocation;